import type { TweetFeedResponseTweetsItemMediaItemDimensions } from './tweetFeedResponseTweetsItemMediaItemDimensions';
import type { TweetFeedResponseTweetsItemMediaItemType } from './tweetFeedResponseTweetsItemMediaItemType';

export type TweetFeedResponseTweetsItemMediaItem = {
  dimensions?: TweetFeedResponseTweetsItemMediaItemDimensions;
  id: string;
  mimeType?: string;
  size?: number;
  thumbnailUrl?: string;
  type: TweetFeedResponseTweetsItemMediaItemType;
  url: string;
};
